/*Metric to imperial conversion for product size charts
  Add following HTML to product page:
	<p class="convertButton" id="centZ" style="cursor: pointer;" onclick="convertMeasure(1)">click for centimeters</p>
	<p class="convertButton" id="inchZ" style="cursor: pointer; display: none;" onclick="convertMeasure(2)">click for inches</p>
*/	
	var convertSwitchIn = true;
    var convertSwitchCm = true;
	var myTable = document.getElementsByTagName('tbody')[0];
    var rowLength = myTable.rows.length;
	var tableData = new Array();

    for(var i = 1; i < rowLength; i++){
      //console.log(i);
      for(var j = 1; j < myTable.rows[i].cells.length; j++){
        tableData.push(myTable.rows[i].cells[j].innerHTML);
      }
    }

	
	function convertMeasure(selection){
        //case 1 selects cm
		if(selection == 1){
            if(convertSwitchIn == true){
                convertCm();
                document.getElementById("centZ").style.display = "none";
                document.getElementById("inchZ").style.display = "inline";
                convertSwitchIn = false;
                convertSwitchCm = true;
            } else {
                //null
            }
        //case 2 selects inches   
		} else if(selection == 2){
            if(convertSwitchCm == true){
                //convertIn();
              	convertIn();
        		document.getElementById("inchZ").style.display = "none";
                document.getElementById("centZ").style.display = "inline";
                convertSwitchCm = false;
                convertSwitchIn = true;
            } else {
                //null
            }
        //fail case returns null
		} else {
			return null;
		}
	}


	function convertCm(){
		var myTable = document.getElementsByTagName('tbody')[0];
      	var rowLength = myTable.rows.length;
		var tempNum;
      	var convertNum;

		//console.log(rowLength);
		for(var i = 1; i < rowLength; i++){
			//console.log(i);
			for(var j = 1; j < myTable.rows[i].cells.length; j++){
              //console.log(myTable.rows[i].cells.length);
              //console.log(myTable.rows[i].cells[j].innerHTML);
              tempNum = parseFloat(myTable.rows[i].cells[j].innerHTML)*2.54;
              convertNum = (Math.round(tempNum * 2) / 2).toFixed(1);
              if(convertNum % 1 == 0){
                myTable.rows[i].cells[j].innerHTML = parseFloat(convertNum).toFixed(0);
              } else {
              	myTable.rows[i].cells[j].innerHTML = convertNum;
              }
              //myTable.rows[i].cells[j].innerHTML = parseFloat(tempNum * 2.54).toFixed(2);
			}
		}
	}

    function convertIn(){
          var myTable = document.getElementsByTagName('tbody')[0];
          var rowLength = myTable.rows.length;
          var counter = 0;
          //console.log(tableData[counter]);
          for(var i = 1; i < rowLength; i++){
            for(var j = 1; j < myTable.rows[i].cells.length; j++){
              //console.log(tableData[counter]);
              myTable.rows[i].cells[j].innerHTML = tableData[counter];
              counter++;
            }
          }
    }


	/*
    old conversion code
	function convertIn(){
		var myTable = document.getElementsByTagName('tbody')[0];
		var rowLength = myTable.rows.length;
		var tempNum;

		for(var i = 1; i < rowLength; i++){
			//console.log(i);
			for(var j = 1; j < myTable.rows[i].cells.length; j++){
				tempNum = parseFloat(myTable.rows[i].cells[j].innerHTML);
				if((tempNum/2.54).toFixed(2) % 1 == 0 ){
					myTable.rows[i].cells[j].innerHTML = parseFloat(tempNum/ 2.54).toFixed(0).toString()+"\"";
				} else if((tempNum/2.54).toFixed(2) % 1 == .5) {
					myTable.rows[i].cells[j].innerHTML = parseFloat(tempNum/ 2.54).toFixed(1).toString()+"\"";
                } else {
					myTable.rows[i].cells[j].innerHTML = parseFloat(tempNum / 2.54).toFixed(2).toString()+"\"";
				}
			}
		}
	}
    */